import mainService from 'services/mainService';

export function systemInfo(portId: number) {
    return mainService
        .get(`pulls/${portId}/systemInfo`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function lastUpdate(portId: number) {
    return mainService
        .get(`pulls/${portId}/0/last`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
